import React from 'react';
import axios from "axios";
import { message  } from 'antd';

const Unsubscribe = (id ,userId ,clientAPIkey,Setfunction,setComplete) => {  
    Setfunction(true);
   if(id!==undefined&&userId!==undefined&&clientAPIkey!==undefined){

    let headersList = {
        "accept": "*/*",
        "Content-Type": "application/json" ,
        'Authorization': clientAPIkey ,
        }
        let reqOptions = {
          url: `${process.env.REACT_APP_BASE_URL}client/add-route?clientId=${userId}&routeId=${id}`,
          method: "POST",
          headers: headersList,
            }
            axios.request(reqOptions).then(function (response) {
            message.success("Successfully unsubscribed to the API")
            Setfunction(false);
            setComplete(true);
            }).catch((error) => {
              message.error(error.message);
              Setfunction(false);
              setComplete(true);
              })      
   }
   else{
      return null;
   }
}

export default Unsubscribe